(function () {
  "use strict";

  brandCrud.$inject = ['brandResource'];
  angular
    .module('branding')
    .directive('brandCrud', brandCrud);

  function brandCrud(brandResource) {
    return {
      restrict: 'A',
      controller: ['$scope', function ($scope) {
        var self = this;
        var contentFileId = null;
        var onFileUploaded;
        var _company;

        this.uploader = null;

        $scope.isDirty = false;

        this.setDirty = function (value) {
          $scope.isDirty = value;
        };


        this.getContentFileId = function (company) {
          if (!self.uploader)
            return;

          _company = company;

          self.uploader.settings.url = '/TrainerGS/UploadNewLogo';
          self.uploader.settings.multipart_params = {
            sessId: mfConfig.sessionId,
            uploadToken: Date.now() + '_' + Math.random(),
            filename: 'filename',
            'key': '${filename}',
            'Content-Type': 'image/*'
          };
        };


        this._deprecated_getContentFileId = function (company) {
          if (!self.uploader || contentFileId) {
            company.logoFileId = contentFileId;
            return;
          }

          _company = company;

          brandResource.contentFile({authRequired: false}).$promise.then(function (result) {
            if (!self.uploader)
              return;

            var info = result.uploadInfo;
            contentFileId = company.logoFileId = result.contentFileId;

            self.uploader.settings.url = info.url;
            self.uploader.settings.multipart_params = {
              // Dummy filename to ensure the field is sent in HTML just like Flash
              // This allow to have a consistent AWS policy for both HTML and Flash
              filename: 'filename',
              // You need to insert some sort of unique identifier to avoid
              // overriding files if they share the same filename.
              'key': info.key + '${filename}',
//            'Filename': '${filename}', // adding this to keep consistency across the runtimes
              'success_action_status': '201',
              'acl': info.acl,
              'Content-Type': 'image/*',
              'AWSAccessKeyId': info.AWSAccessKeyId,
              'policy': info.policy,
              'signature': info.signature
            };
          });
        };


        this.saveLogo = function (cb) {
          if (!self.uploader || !_company)
            return cb();

          if (onFileUploaded) {
            self.uploader.removeEventListener('FileUploaded', onFileUploaded);
          }

          onFileUploaded = function (uploader, file, result) {

            var newResult = angular.fromJson(result.response);
            _company.logoFileId = newResult.contentFileId;

            if (cb) cb();
          };

          self.uploader.addEventListener('FileUploaded', onFileUploaded);

          self.uploader.start();
        };

        this.resetting = false;

        $scope.$on('$destroy', function () {
          if (self.uploader)
            self.uploader.destroy();
        });
      }]
    };
  }

})();
